import styled from 'styled-components';
import { colours, spacing } from '../../../stylings';

export const MegaMenuWrapper = styled.div`
  gap: 28px;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 70px ${spacing.L};
`;

export const RowWrapper = styled.div<{ $alignLeft?: boolean }>`
  display: flex;
  gap: ${({ $alignLeft }) => $alignLeft && '64px'};
  justify-content: ${({ $alignLeft }) => ($alignLeft ? 'left' : 'space-between')};
  width: 100%;

  a {
    color: ${colours.BLACK};
    text-decoration: none;
  }
`;

export const FeaturedCardContainer = styled.div`
  display: flex;
  gap: 18px;
  margin: 0 auto;
`;
